import { render, staticRenderFns } from "./HomeForWaitersService.vue?vue&type=template&id=184c86a6&scoped=true&lang=pug"
import script from "./HomeForWaitersService.vue?vue&type=script&lang=ts"
export * from "./HomeForWaitersService.vue?vue&type=script&lang=ts"
import style0 from "./HomeForWaitersService.vue?vue&type=style&index=0&id=184c86a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184c86a6",
  null
  
)

export default component.exports